import React from 'react'
import { Link } from 'react-router-dom'
import { IoIosArrowBack } from 'react-icons/io'
import { FilledInput, FormControl, InputAdornment, InputLabel } from '@mui/material'
import Button from '../shared/Button'

const Trackorder = () => {
    return (
        <div className="min-h-[80vh]">
            <div className="flex justify-center">
                <div className="bg-white rounded-md mt-[8vh] p-4">
                    <div className="flex items-center">
                        <Link to="/menu">
                            <span className="h-7 w-7 rounded-full border-light-secondary border-2 bg-gray-100 flex items-center justify-center font-bold cursor-pointer hover:bg-light-secondary text-light-secondary hover:text-white">
                                <IoIosArrowBack className="font-bold" size={20} />
                            </span>
                        </Link>
                        <h1 className="text-4xl font-bold ml-4">Track Order</h1>
                    </div>
                    <div className="w-[50%] px-12"></div>
                    <div className="flex p-10 gap-3">
                        <FormControl fullWidth variant="filled">
                            <InputLabel htmlFor="filled-adornment-amount">Phone Number (3XXXXXXXXX)<span className="text-red-500">*</span></InputLabel>
                            <FilledInput
                                id="filled-adornment-amount"
                                startAdornment={<InputAdornment position="start">
                                    <span className="font-bold">+92 </span>
                                </InputAdornment>}
                            />
                        </FormControl>
                        <FormControl fullWidth variant="filled">
                            <InputLabel htmlFor="filled-adornment-amount">Order Id <span className="text-red-500">*</span></InputLabel>
                            <FilledInput
                                id="filled-adornment-amount"
                                startAdornment={<InputAdornment position="start">
                                    {/* <span className="font-bold">+92</span> */}
                                </InputAdornment>}
                            />
                        </FormControl>
                    </div>
                    <div className="flex justify-center">
                        <Button type="solid" data="Track" styles="bg-[#E4002B45] text-black" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Trackorder